import React from 'react';

import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import MapMarkerIcon from './icons/MapMarkerIcon';
import SocialWallIcon from './icons/SocialWallIcon';
import CardIcon from './icons/CardIcon';
import ProfileIcon from './icons/ProfileIcon';
import { useSelector } from 'react-redux';

export const Navbar = () => {
    const cardData = useSelector(state => state.user.cardData);
    
    return (
            <nav>
                <section>
            
                    <div className="navContent">
                        <div className="navLinks">
                            <NavLink to="/home" activeClassName="selected">
                                <FontAwesomeIcon icon={faHome}/>
                            </NavLink>
                            <NavLink to="/map" activeClassName="selected">
                                <MapMarkerIcon/>
                            </NavLink>
                            <NavLink to="/social-wall" activeClassName="selected">
                                <SocialWallIcon/>
                            </NavLink> 
                            {cardData.inapp_user == 1 ? null : <NavLink to="/card" activeClassName="selected">
                                <CardIcon/>
                            </NavLink>}
                             <NavLink to="/profile" activeClassName="selected">
                                <ProfileIcon/>
                            </NavLink>
                        </div>
                    </div>
                </section>
            </nav>
            )
};

export default Navbar;